module.exports = __webpack_public_path__ + "static/media/icon_occlusion.dcfd7e2f.svg";